export default {
    tokens: {
        access: '',
        refresh: '',
    },
    data: {
        email: '',
        password: '',
    },
    loading: false,
    success: false,
    error: false,
}
